import { useState } from 'react';
import plusIcon from '../../assets/icons/plusIcon.svg';
import minusIcon from '../../assets/icons/minusIcon.svg';
import redCrossIcon from '../../assets/icons/redCrossIcon.svg';

function Faq() {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);

  const contraindications = [
    {
      id: 1,
      description: "Не рекомендуется при критических днях."
    },
    {
      id: 2,
      description: "Гинекологические заболевания, в том числе миома (процедура возможна при разрешении лечащего врача);"
    },
    {
      id: 3,
      description: "6 месяцев после родов КС;"
    },
    {
      id: 4,
      description: "2 месяца после естественных родов;"
    },
    {
      id: 5,
      description: "Наличие кардиостимуляторов;"
    },
    {
      id: 6,
      description: "Ишемическая болезнь 2-й и 3-й степени;"
    },
    {
      id: 7,
      description: "Сердечная аритмия;"
    },
    {
      id: 8,
      description: "Заболевания с повышенным риском кровотечений;"
    },
    {
      id: 9,
      description: "Мочекаменная болезнь;"
    },
    {
      id: 10,
      description: "Доброкачественные и злокачественные опухоли;"
    },
    {
      id: 11,
      description: "Варикоз 2-й и 3-й степени;"
    },
    {
      id: 12,
      description: "Кожные воспаления;"
    },
    {
      id: 13,
      description: "Гипертония 3-й степени;"
    },
    {
      id: 14,
      description: "Тромбоз, тромбофлебит и заболевания с повышенным риском образования тромбов;"
    },
    {
      id: 15,
      description: "Беременность;"
    },
    {
      id: 16,
      description: "Туберкулёз;"
    }
  ]

  const duration = [
    {
      id: 1,
      description: 'Целенаправленное воздействие на проблемные зоны по авторской методике;'
    },
    {
      id: 2,
      description: 'Персональную консультацию специалиста;'
    },
    {
      id: 3,
      description: 'Мотивационную поддержку;'
    },
    {
      id: 4,
      description: 'Индивидуальный подход к вашим потребностям.'
    },
  ]

  const quantity = [
    {
      id: 1,
      title: 'Снижение веса на 3-6 кг:',
      description: 'Рекомендуемый курс — 10 процедур с частотой 2-3 раза в неделю.',
    },
    {
      id: 2,
      title: 'Снижение веса на 6-11 кг:',
      description: 'Для достижения желаемого результата потребуется 14-16 процедур с частотой 2-3 раза в неделю.',
    },
    {
      id: 3,
      title: 'Повышение упругости и тонуса кожи:',
      description: 'Оптимальный курс — 7-8 сеансов, 2 раза в неделю.',
    },
    {
      id: 4,
      title: 'Уменьшение отечности и общее оздоровление:',
      description: 'Рекомендуется 10 процедур: первые 5 сеансов — 2 раза в неделю, последующие 5 — 1 раз в неделю.',
    },
  ]

  return ( 
    <div className="faq" id='faq'>
      <div className='faq__bg1'></div>
      <div className='faq__bg2'></div>
      <div className='faq__list'>
        <div className='faq__item item'>
          <div className='item__header' onClick={() => {setIsOpen(!isOpen)}}>
            <p className='item__header-text'>Какие есть противопоказания?</p>
            <button className='item__header-btn'>
              {!isOpen &&
                <img src={plusIcon} alt="плюс" />
              }
              {isOpen &&
                <img src={minusIcon} alt="плюс" />
              }
            </button>
          </div>
          <div className={`item__content content ${isOpen ? 'active' : ''}`}>
            <p className='content__text'>Несмотря на высокую эффективность и широкий спектр действия, у процедуры подводно-вакуумного массажа есть ряд противопоказаний!</p>
            <p className='content__text'>Все заболевания в острой стадии:</p>
            <div className='content__list'>
              {contraindications.map(item => (
                <div key={item.id} className='content__list-item'>
                  <img className='content__list-img' src={redCrossIcon} alt="" />
                  <p className='content__list-text-red'>{item.description}</p>
                </div>
              ))}
            </div>
            <p className='content__text'>Обратите внимание, что процедура разрешена при лактациии варикозе 1-й степени.</p>
          </div>
        </div>
        <div className='faq__item item'>
          <div className='item__header' onClick={() => {setIsOpen2(!isOpen2)}}>
            <p className='item__header-text'>Почему стоит выбрать гидро-вакуумный массаж?</p>
            <button className='item__header-btn'>
              {!isOpen2 &&
                <img src={plusIcon} alt="плюс" />
              }
              {isOpen2 &&
                <img src={minusIcon} alt="плюс" />
              }
            </button>
          </div>
          <div className={`item__content content ${isOpen2 ? 'active' : ''}`}>
            <p className='content__text'>Гидро-вакуумный массаж сочетает воздействие воды и вакуума, что усиливает эффект по сравнению с традиционным массажем. Это более интенсивная процедура, которая позволяет достичь заметных результатов за меньшее количество сеансов.</p>
          </div>
        </div>
        <div className='faq__item item'>
          <div className='item__header' onClick={() => {setIsOpen3(!isOpen3)}}>
            <p className='item__header-text'>Сколько длится сеанс?</p>
            <button className='item__header-btn'>
              {!isOpen3 &&
                <img src={plusIcon} alt="плюс" />
              }
              {isOpen3 &&
                <img src={minusIcon} alt="плюс" />
              }
            </button>
          </div>
          <div className={`item__content content ${isOpen3 ? 'active' : ''}`}>
            <p className='content__text'>Один сеанс комплексной процедуры, включающей в себя подводный вакуумный массаж, ручной душ-массаж и жемчужную ванну, занимает от 45 до 60 минут в зависимости от выбранного вами пакета услуг. В течение сеанса вы получите:</p>
            <div className='content__list'>
              {duration.map(item => (
                <div key={item.id} className='content__list-item'>
                  <p className='content__list-text-blue'>·</p>
                  <p className='content__list-text-blue'>{item.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className='faq__item item'>
          <div className='item__header' onClick={() => {setIsOpen4(!isOpen4)}}>
            <p className='item__header-text'>Что необходимо взять с собой на сеанс?</p>
            <button className='item__header-btn'>
              {!isOpen4 &&
                <img src={plusIcon} alt="плюс" />
              }
              {isOpen4 &&
                <img src={minusIcon} alt="плюс" />
              }
            </button>
          </div>
          <div className={`item__content content ${isOpen4 ? 'active' : ''}`}>
            <p className='content__text'>Вам не нужно беспокоиться о принадлежностях для процедуры — мы предоставляем все необходимое: полотенца, одноразовое белье, тапочки и шапочку, а также резинки для волос. Если вы предпочитаете использовать свой купальник, возьмите с собой раздельный, чтобы обеспечить доступ к зоне живота и боков.</p>
          </div>
        </div>
        <div className='faq__item item'>
          <div className='item__header' onClick={() => {setIsOpen5(!isOpen5)}}>
            <p className='item__header-text'>Сколько процедур гидро-вакуумного массажа необходимо?</p>
            <button className='item__header-btn'>
              {!isOpen5 &&
                <img src={plusIcon} alt="плюс" />
              }
              {isOpen5 &&
                <img src={minusIcon} alt="плюс" />
              }
            </button>
          </div>
          <div className={`item__content content ${isOpen5 ? 'active' : ''}`}>
            <p className='content__text'>Количество сеансов зависит от ваших целей:</p>
            {quantity.map(item => (
              <div className='content__list' key={item.id}>
                <p className='content__text-title'>{item.title}</p>
                <p className='content__text-description'>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className='faq__right'>
        <h2 className='faq__right-title faq__right-black'>ОСТАЛИСЬ ВОПРОСЫ?</h2>
        <h2 className='faq__right-title faq__right-blue'>У НАС ЕСТЬ ОТВЕТЫ!</h2>
      </div>
    </div>
   );
}

export default Faq;